<div mat-dialog-content fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px">
  <h1 class="text-weight-bold">ERROR</h1>
  <!-- <p class="text-weight-bold">You will need add a payment gateway to continue in adding subscriptions</p> -->
  <p class="text-weight-bold">{{ data.text }}</p>
  <div fxLayout="row" fxLayoutGap="20px">
    <button mat-flat-button class="btn-goback" (click)="handleGoback()">Go back</button>
    <button mat-flat-button color="primary" (click)="handleAddPaymentGateway()">Add Payment Gateway</button>
  </div>
</div>
